export const APP_KEY = '5b80af378d9746d98ff92ff1dfe94525';
// @ts-ignore
export const ERP_DOMAIN = window.location.origin;
export const LOGIN_PATH = ERP_DOMAIN + '/login.aspx';

// 通用首页的 iframe id
export const WELCOME_PAGE_NAME = '聚水潭欢迎您';
export const WELCOME_IFRAME_ID = `iframe-${WELCOME_PAGE_NAME}`;
export const WELCOME_TAB = {
  tabKey: WELCOME_PAGE_NAME,
  name: WELCOME_PAGE_NAME,
  url: ERP_DOMAIN,
  isPinned: true,
  isErp: true,
};

// 客服 dom id
export const CUSTOMER_DOM_ID = 'kefu';

// 缓存 erp 侧变量名称
export const CACHE_IFRAME_WINDOW_FNS = ['_Confirm'];

export const NO_SERVICE_AUTHORIZATION_LIST = ['GoodResourcePack'];

/** 限流时不弹出提示的接口 */
export const SILENT_PORTS_ON_LIMIT = {
  code: 429,
  ports: [
    '/epaas/manager/queryMenuTree',
    '/epaas/manager/templateUpdateMessage',
    '/epaas/manager/queryWidgets',
  ],
};

/** 不显示错误提示的静默接口 */
export const SILENT_PORTS = [
  '/marketing/popularize/notice/getNoticeListByPagePosition',
  '/usercenter/AuthApi/WebLogin/AccountSwitch',
  '/usercenter/AuthApi/WebLogin/AccountSwitchSmsSend',
  '/usercenterapi/Passport/ApplyLogout',
  '/jst-data-business/cms/assetmanager/loginQrcode',
];

/** 公告枚举 */
export const NOTICE_KEY_MAPPING = {
  商品多店铺货: 'ERP_GOODSMATERIALMANAGE_NOTICE',
  普通商品资料: 'ERP_GOODSDATA_NOTICE',
  导入订单: 'ERP_ORDER_IMPORT_NOTICE',
  '售后（极速版）': 'ERP_AFTERSALE_SPEED_NOTICE',
  店铺设置: 'ERP_STORESETTING_NOTICE',
  打单拣货: 'ERP_PRINT_NOTICE',
  订单: 'ERP_ORDER_NOTICE',
  全局: 'SYSREM_NOTICE',
};
